import styled from 'styled-components'
import { ExpandIconProps } from './types'

export const Container = styled.div`
  display: flex;
  overflow-y: auto;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  padding: 20px;
`

export const SearchSection = styled.div`
  margin-bottom: 20px;
`

export const SearchInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 16px;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

  &:focus {
    outline: none;
    border-color: #0066ff;
    box-shadow: 0 0 0 2px rgba(0, 102, 255, 0.2);
  }
`

export const FilterHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-top: 8px;
`

export const FilterSectionTitle = styled.h3`
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
`

export const ClearFiltersButton = styled.button`
  padding: 6px 12px;
  background-color: #f0f0f0;
  color: #333;
  border: none;
  border-radius: 16px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #e0e0e0;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 102, 255, 0.3);
  }
`

export const FiltersContainer = styled.div`
  margin-bottom: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 16px;
`

export const FilterSection = styled.div`
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const FilterPillsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const FilterPill = styled.button<{ selected: boolean }>`
  padding: 6px 12px;
  background-color: ${(props) => (props.selected ? '#0066ff' : 'white')};
  color: ${(props) => (props.selected ? 'white' : '#555')};
  border: 1px solid ${(props) => (props.selected ? '#0066ff' : '#ddd')};
  border-radius: 16px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
  box-shadow: ${(props) =>
    props.selected ? '0 2px 4px rgba(0, 102, 255, 0.2)' : 'none'};

  &:hover {
    background-color: ${(props) => (props.selected ? '#0052cc' : '#f5f5f5')};
    border-color: ${(props) => (props.selected ? '#0052cc' : '#ccc')};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 102, 255, 0.3);
  }
`

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
`

export const TagButton = styled.button<{ selected: boolean }>`
  padding: 6px 12px;
  background-color: ${(props) => (props.selected ? '#0066ff' : '#f0f0f0')};
  color: ${(props) => (props.selected ? 'white' : '#333')};
  border: none;
  border-radius: 16px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props) => (props.selected ? '#0052cc' : '#e0e0e0')};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 102, 255, 0.3);
  }
`

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const EmptyState = styled.div`
  padding: 40px;
  text-align: center;
  color: #666;
  font-size: 16px;
  background-color: #f9f9f9;
  border-radius: 8px;
`

export const LoadingIndicator = styled.div`
  padding: 16px;
  text-align: center;
  color: #666;
`

export const ErrorMessage = styled.div`
  padding: 40px;
  text-align: center;
  color: #e53935;
  background-color: #ffebee;
  border-radius: 8px;
`

export const HierarchicalList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const StyledClubItem = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`

export const ClubHeader = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  background-color: #f8f9fa;
  cursor: pointer;
  border-bottom: 1px solid #e0e0e0;

  &:hover {
    background-color: #f1f3f5;
  }

  &:focus {
    outline: none;
    box-shadow: inset 0 0 0 2px #0066ff;
  }
`

export const ClubHeaderMain = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`

export const ClubHeaderInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: 24px;
  flex-wrap: wrap;
`

export const ClubInfoBadge = styled.span`
  font-size: 13px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background-color: #f1f3f5;
  border-radius: 4px;

  strong {
    color: #2a2a2a;
    font-weight: 500;
  }
`

export const BranchStatusBadge = styled.span<{ isBranched: boolean }>`
  font-size: 13px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: ${({ isBranched }) => (isBranched ? '#d3f9d8' : '#f1f3f5')};
  color: ${({ isBranched }) => (isBranched ? '#2b8a3e' : '#495057')};
`

export const ExpandIcon = styled.span<ExpandIconProps>`
  margin-right: 8px;
  font-size: 12px;
  transition: transform 0.2s ease;
  width: 16px;
  text-align: center;
  transform: ${(props) => (props.expanded ? 'rotate(0deg)' : 'rotate(-90deg)')};
`

export const ClubName = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  flex: 1;
  color: #1a1a1a;
`

export const CourseCount = styled.span`
  font-size: 14px;
  color: #666;
`

export const CourseList = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledCourseItem = styled.div`
  border-top: 1px solid #eee;
`

export const CourseHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px 12px 32px;
  background-color: #fff;
  cursor: pointer;

  &:hover {
    background-color: #f9f9f9;
  }

  &:focus {
    outline: none;
    box-shadow: inset 0 0 0 2px #0066ff;
  }
`

export const CourseName = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  flex: 1;
`

export const EvaluationCount = styled.span`
  font-size: 14px;
  color: #666;
`

export const EvaluationList = styled.div`
  display: flex;
  flex-direction: column;
`

export const EvaluationItem = styled.div`
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 16px;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #f8f9fa;
  }

  &:focus {
    outline: none;
    box-shadow: inset 0 0 0 2px #0066ff;
  }
`

export const EvaluationMainContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const EvaluationTitle = styled.h4`
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #1a1a1a;
`

export const EvaluationMetaRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
`

export const EvaluationMeta = styled.span`
  font-size: 14px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 4px;

  strong {
    color: #2a2a2a;
    font-weight: 500;
  }
`

export const StatusBadge = styled.span<{ status: number }>`
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  background-color: ${({ status }) => {
    switch (status) {
      case 0:
        return '#f1f3f5'
      case 1:
        return '#fff3bf'
      case 2:
        return '#d0ebff'
      case 3:
        return '#d3f9d8'
      default:
        return '#f1f3f5'
    }
  }};
  color: ${({ status }) => {
    switch (status) {
      case 0:
        return '#495057'
      case 1:
        return '#5c4813'
      case 2:
        return '#1864ab'
      case 3:
        return '#2b8a3e'
      default:
        return '#495057'
    }
  }};
`

export const ManualVersionBadge = styled.span<{ version: string }>`
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
  background-color: ${({ version }) => {
    switch (version) {
      case '2020':
        return '#f1f3f5'
      case '2024':
        return '#f1f3f5'
      default:
        return '#f1f3f5'
    }
  }};
`

export const EvaluationDescription = styled.p`
  margin: 8px 0 0 0;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  max-width: 800px;
`

export const ClubDetails = styled.div`
  padding: 16px 20px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
`

export const DetailItem = styled.div`
  margin: 0;
  font-size: 14px;
  color: #4a4a4a;
  display: flex;
  align-items: center;
  gap: 8px;

  strong {
    color: #2a2a2a;
    font-weight: 500;
  }
`
